import * as React from "react";

import { locKeys } from "../l10";

import { UitkIcon, UitkIconSize } from "@egds/react-core/icons";
import { UitkLayoutFlex } from "@egds/react-core/layout-flex";
import { UitkSpacing } from "@egds/react-core/spacing";
import { UitkHeading, UitkText } from "@egds/react-core/text";
import { useLocalization } from "@shared-ui/localization-context";

import type { FlightsLink } from "typings/microserviceModels/flights-flex-module";

interface FlightDetailsProps {
  flight: FlightsLink;
  airCarrierEBF: string;
  isMobile: boolean;
  isOutBound: boolean;
  showCityName: boolean;
}

export const FlightLegDetails: React.FC<FlightDetailsProps> = ({
  flight,
  airCarrierEBF,
  isMobile,
  isOutBound,
  showCityName,
}) => {
  const { formatText } = useLocalization();

  let departureCity;
  let destinationCity;

  if (isOutBound) {
    departureCity = showCityName ? flight.origin.cityName : flight.origin.name;
    destinationCity = showCityName ? flight.destination.cityName : flight.destination.name;
  } else {
    departureCity = showCityName ? flight.destination.cityName : flight.destination.name;
    destinationCity = showCityName ? flight.origin.cityName : flight.origin.name;
  }

  const departureAirportCode = isOutBound ? flight.origin.code : flight.destination.code;
  const destinationAirportCode = isOutBound ? flight.destination.code : flight.origin.code;
  const airCarrierName = (isOutBound ? flight.airCarrier?.name : flight.inboundAirCarrier?.name) ?? airCarrierEBF;

  const locArgs = [departureAirportCode, destinationAirportCode, airCarrierName];

  return (
    <UitkSpacing padding={{ inlineend: "three" }}>
      <div>
        <UitkSpacing margin="unset">
          <UitkHeading size={isMobile ? 6 : 5}>
            <UitkLayoutFlex alignItems="center">
              {departureCity}
              <UitkSpacing margin={{ inline: "two" }}>
                <UitkIcon name="arrow_forward" size={UitkIconSize.EXTRA_SMALL} />
              </UitkSpacing>
              {destinationCity}
            </UitkLayoutFlex>
          </UitkHeading>
        </UitkSpacing>

        <UitkSpacing margin={{ blockstart: "one" }}>
          <UitkText size={200} theme="secondary" weight="regular">
            {formatText(locKeys.flightAirportsWithAirline, ...locArgs)}
          </UitkText>
        </UitkSpacing>
      </div>
    </UitkSpacing>
  );
};
